import React from 'react';
import styled from 'styled-components';
import {analyticsTrackAction} from '../../helpers/Analytics';

const DKidsScrollTopButton = ({visible, live}) => {
    const scrollToTop = () => {
        analyticsTrackAction('dkids|scrollcta');
        window.scrollTo({top: 0, behavior: 'smooth'});
    };

    return (
        <Container visible={visible} onClick={scrollToTop}>
            <img
                src={require('../../assets/dkids/ill_up_button.png')}
                alt="Scroll To Top"
            />
            <TextContainer>
                <Title>{live.description}</Title>
                <Subtitle>{live.title}</Subtitle>
            </TextContainer>
            <Arrow src={require('../../assets/dkids/ic_arrow_up.png')} />
        </Container>
    );
};

const Container = styled.div`
    position: fixed;
    background: #ff5077;
    box-shadow: 0px 30px 40px rgba(0, 0, 0, 0.4);
    border-radius: 40px;
    display: flex;
    flex-direction: row;
    bottom: 20px;
    right: 20px;
    transition: opacity 0.5s ease-in-out;
    opacity: ${props => (props.visible ? 1 : 0)};
    pointer-events: ${props => (props.visible ? 'auto' : 'none')};
    cursor: pointer;
    align-items: center;
    justify-content: center;
    padding: 10px 16px;
    z-index: 100;
`;

const TextContainer = styled.div`
    margin: 0px 15px;
    display: flex;
    flex-direction: column;
`;

const Title = styled.div`
    font-family: Mont;
    font-weight: 900;
    font-size: 20px;
    text-transform: uppercase;
`;

const Subtitle = styled.div`
    font-family: Mont;
    font-weight: 300;
    font-size: 12px;
    text-transform: uppercase;
`;

const Arrow = styled.img`
    margin-bottom: 2px;
`;

export default DKidsScrollTopButton;
